import React from 'react';

const BuildingIntro = () => {
  return (
    <>
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Building with ASI1</h2>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-8">
        <p className="text-gray-700 leading-relaxed">
          ASI1 is a family of <strong>highly performant and intelligent AI models</strong> built by Fetch.ai. While ASI1 is powerful and extensible, it's also the most trustworthy and reliable AI available for Web3 applications. It follows critical protocols, makes fewer mistakes, and is resistant to manipulation—allowing enterprise customers to build the safest agentic AI-powered applications at scale within decentralized environments.
        </p>
      </div>
      <p className="text-gray-700 leading-relaxed mb-8">
        This guide introduces ASI1's enterprise capabilities, the end-to-end flow for developing with ASI1 agents, and how to start building autonomous applications in the Web3 ecosystem.
      </p>

      {/* Legacy Building with ASI1 content */}
      <p className="text-gray-700 leading-relaxed mb-8">
        ASI1 is designed to empower enterprises and developers at scale with strong performance across Web3 applications, agentic AI workflows, and decentralized systems. Here's what you can accomplish with ASI1:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-700 mb-4">Web3 & Blockchain</h3>
          <ul className="space-y-2 text-gray-700">
            <li>• Smart contract analysis and optimization</li>
            <li>• DeFi protocol interactions and strategies</li>
            <li>• On-chain data analysis and insights</li>
            <li>• Automated trading and portfolio management</li>
            <li>• Cross-chain bridge operations</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-700 mb-4">Agentic AI Applications</h3>
          <ul className="space-y-2 text-gray-700">
            <li>• Autonomous agent orchestration</li>
            <li>• Multi-step task execution</li>
            <li>• Context-aware decision making</li>
            <li>• Goal-driven problem solving</li>
            <li>• Adaptive reasoning and planning</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-700 mb-4">Enterprise Features</h3>
          <ul className="space-y-2 text-gray-700">
            <li>• Enterprise-grade security and compliance</li>
            <li>• Scalable API integration</li>
            <li>• High-throughput processing</li>
            <li>• Custom model fine-tuning</li>
            <li>• Comprehensive monitoring and analytics</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-blue-700 mb-4">Integration Capabilities</h3>
          <ul className="space-y-2 text-gray-700">
            <li>• RESTful API access</li>
            <li>• WebSocket real-time connections</li>
            <li>• SDK support for multiple languages</li>
            <li>• Webhook event notifications</li>
            <li>• Cloud and on-premise deployment</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default BuildingIntro;
